import config from './configuration'
import ConstantsList from '../common/SupplierConstants';

// this block needed to get the login Token and Login user _id 
let localData = localStorage.getItem('userData');
let userData={}
if(localData){
    userData = JSON.parse(localData);
}

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

/* Service Function starts here */

//POST - getMenuOnUserRole
async function getMenuOnUserRole(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/getMenu";
    return callPOST(api_url, param);
}

// get info from the configuration.js file
async function getConfig() {
    return config;
}

//POST - Get User Login Details using _id
async function getLoginUserData() { // This method calling from Redux
    let api_url= config.BASE_URL + 'api/getUserDetails';
    let param = {"_id" : userData.data._id}
    return callPOST(api_url, param);
}

// API Error Handling
async function handleResponseError(response) {
    throw new Error("HTTP error, status = " + response.status);
}

// API Error Handling
async function handleError(error) {
    console.log(error.message);
}

// Common GET Method 
async function callGET(api_url) {
    return fetch(api_url,{
                method:'GET',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json",
                    "Authorization": 'Bearer '+ userData.token
                }
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                if(items.responseCode !== 401){
                    // console.log(">> GET Service Call",items);
                    return items;
                }else{
                    console.log(">> Session Timeout",items);
                    localStorage.setItem('token',''); 
                    localStorage.setItem('userData','');
                    window.location = ConstantsList.LOGIN;
                }            
            }).catch(error => {
                console.log(">> e", error);
                handleError(error);
            });
}

// Common POST Method
async function callPOST(api_url,param) {
    // console.log(">> check URL", api_url);
    if(!param){
        param = {}
    }
    param.timeZone = userTimezone;
    return await fetch(api_url,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json",
                    "Authorization": 'Bearer '+ userData.token
                },
                body:JSON.stringify(param)
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                // console.log(">> Service Login Data",items);
                if(items.responseCode !== 401){
                    // console.log(">> POST Service Call",items);
                    return items;
                }else{
                    console.log(">> Session Timeout",items);
                    localStorage.setItem('token',''); 
                    localStorage.setItem('userData','');
                    window.location = ConstantsList.LOGIN;
                }     
               
            }).catch(error => {
                handleError(error);
            });
}

// Common POST Method for Upload
async function callPOSTUpload(api_url,param) {
    // console.log(">>callPOSTUpload param ", param);
    return await fetch(api_url,{
                method:'POST',
                headers:{
                    // 'Content-Type': 'multipart/form-data',
                    "Authorization": 'Bearer '+ userData.token,
                },
                body:param
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                // console.log(">> Service Login Data",items);
                if(items.responseCode !== 401){
                    // console.log(">> POST Service Call",items);
                    return items;
                }else{
                    console.log(">> Session Timeout",items);
                    localStorage.setItem('token',''); 
                    localStorage.setItem('userData','');
                    window.location = ConstantsList.LOGIN;
                }     
               
            }).catch(error => {
                handleError(error);
            });
}

//POST - Upload files
async function uploadFiles(param) {
    let api_url= config.BASE_URL + 'api/uploadFiles';
    return callPOSTUpload(api_url,param);
}
//POST - Upload Article
async function uploadArticleFile(param) {
    let api_url= config.BASE_URL + 'api/uploadArticleFile';
    return callPOSTUpload(api_url,param);
}
//POST - getUploadedFiles files
async function getUploadedFiles(param) {
    let api_url= config.BASE_URL + 'api/getUploadedFiles';
    return callPOST(api_url,param);
}

/* ---------------------------- Dashboard --------------------------------*/

//dashboard - supplier // "Yearly", "Monthly", "Custom"
async function dashboard(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/dashboard";
    return callPOST(api_url, param);
}

//Generate Chart Query
async function generateChartQuery(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/generateChartQuery";
    return callPOST(api_url, param);
}


/* ---------------------------- AP Automation APP --------------------------------*/

// AP List 
async function generatePlmQuery(param) {// This method calling from Redux
    let api_url = config.BASE_URL + "customer/api/generateCustomerQuery";
    return callPOST(api_url, param);
}

/* ---------------------------- Workflow --------------------------------*/

//POST - getWorkflowInboxCards
async function getWorkflowInboxCards(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/workflowInboxCards";
  return callPOST(api_url, param);
}

//POST - getworkflowInboxList
async function getworkflowInboxList(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/workflowInboxList";
  return callPOST(api_url, param);
}

//POST - workflowApproveReject
async function workflowApproveReject(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/actionOnCustomerWorkflowEvent";
  return callPOST(api_url, param);
}

//workflowActionAPI
async function workflowActionAPI(URL, param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + URL;
  return callPOST(api_url, param);
}

async function addBudget(param) {
  let api_url = config.BASE_URL + "apauto/api/addBudget";
  return callPOST(api_url, param);
}
async function deleteBudget(param) {
  let api_url = config.BASE_URL + "apauto/api/deleteBudget";
  return callPOST(api_url, param);
}
async function updateBudget(param) {
  let api_url = config.BASE_URL + "apauto/api/updateBudget";
  return callPOST(api_url, param);
}

async function budgetCards(param) {
  let api_url = config.BASE_URL + "apauto/api/getBudgetCard";
  return callPOST(api_url, param);
}

async function cancleAPInvoice(param) {
  let api_url = config.BASE_URL + "apauto/api/cancleAPInvoice";
  return callPOST(api_url, param);
}
async function createAPInvoice(param) {
  let api_url = config.BASE_URL + "apauto/api/createAPInvoice";
  return callPOST(api_url, param);
}
async function updateAPInvoice(param) {
  let api_url = config.BASE_URL + "apauto/api/updateAPInvoice";
  return callPOST(api_url, param);
}

async function generateCustomerQuery(param) {// This method calling from Redux
    let api_url = config.BASE_URL + "customer/api/generateCustomerQuery";
    return callPOST(api_url, param);
}
async function getModuleStats(param) {
  let api_url = config.BASE_URL + "apauto/api/getModuleStats";
  return callPOST(api_url, param);
}
async function updateAPstatus(param) {
  let api_url = config.BASE_URL + "apauto/api/updateAPstatus";
  return callPOST(api_url, param);
}
async function createPayment(param) {
  let api_url = config.BASE_URL + "apauto/api/createPayment";
  return callPOST(api_url, param);
}
async function addSaleOrder(param) {
  let api_url = config.BASE_URL + "customer/api/addSaleOrder";
  return callPOST(api_url, param);
}

const func = {    
    handleResponseError,
    handleError,
    callGET,
    callPOST,
    callPOSTUpload, 

    getMenuOnUserRole,
    getConfig,
    getLoginUserData,
    uploadFiles,
    getUploadedFiles,    
    
    generateChartQuery,
    dashboard,

    uploadArticleFile,
    generatePlmQuery,
    
    getWorkflowInboxCards,
    getworkflowInboxList,
    workflowApproveReject,
    workflowActionAPI,
    addBudget,
    deleteBudget,
    updateBudget,
    generateCustomerQuery,
    budgetCards,
    cancleAPInvoice,
    createAPInvoice,
    updateAPInvoice,
    getModuleStats,
    updateAPstatus,
    createPayment,
    addSaleOrder
};

export default func;